import React from 'react';
import { Gift } from 'lucide-react';
interface BonusCardProps {
  image: string;
  title: string;
  description: string;
  value?: string;
}
export function BonusCard({
  image,
  title,
  description,
  value
}: BonusCardProps) {
  return <div className="bg-white rounded-xl overflow-hidden shadow-md border border-amber-100 flex flex-col md:flex-row" data-id="element-1">
      <div className="md:w-2/5 h-64 md:h-auto relative overflow-hidden bg-amber-50" data-id="element-2">
        <img src={image} alt={title} className="w-full h-full object-contain p-4 hover:scale-105 transition-transform duration-500" data-id="element-3" />
        <div className="absolute top-4 left-4 bg-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm" data-id="element-4">
          GRATIS
        </div>
      </div>
      <div className="p-6 md:w-3/5 flex flex-col justify-center" data-id="element-5">
        <div className="flex items-center gap-2 mb-2 text-amber-600 font-semibold text-sm uppercase tracking-wider" data-id="element-6">
          <Gift className="w-4 h-4" data-id="element-7" />
          <span data-id="element-8">Bono Exclusivo</span>
        </div>
        <h3 className="text-xl md:text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-9">
          {title}
        </h3>
        <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-10">{description}</p>
        {value && <p className="text-sm text-gray-500" data-id="element-11">
            Valorado en: <span className="line-through" data-id="element-12">{value}</span>{' '}
            <span className="text-green-600 font-bold ml-1" data-id="element-13">HOY GRATIS</span>
          </p>}
      </div>
    </div>;
}